module.exports = __webpack_public_path__ + "static/img/119_TO8_1654_og.2f36e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/119_TO8_1654_og.jpg
// module id = oOT8
// module chunks = 0